import { render, staticRenderFns } from "./FactoringNovedadesNuestroDía.vue?vue&type=template&id=4bd912c6"
import script from "./FactoringNovedadesNuestroDía.vue?vue&type=script&lang=js"
export * from "./FactoringNovedadesNuestroDía.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports